<script setup lang="ts">
import MultiComboboxInput from '@/components/selectBox/combobox/MultiComboboxInput.vue';
import { Selectable } from '@/components/selectBox/selectBox';
import { useStudentParentsSearch } from '@/hooks/search/useStudentParentsSearch';

const { studentParentOptions, isLoading, onQueryChange } = useStudentParentsSearch();

defineProps<{
  modelValue: Selectable<number>[];
}>();

defineEmits(['update:modelValue']);
</script>

<template>
  <MultiComboboxInput
    :options="studentParentOptions"
    :onFilter="onQueryChange"
    :isLoading="isLoading"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @open="() => onQueryChange('')"
  />
</template>
